export function insertAtSelection(current: string, insert: string, start: number, end: number) {
  return current.slice(0, start) + insert + current.slice(end);
}
